import React, { useState, useEffect } from 'react';
import {
  DefaultQueryParams,
  getAmountWithCurrency,
  parseNumberByPrecision,
  parseQuery,
  setTranslationValues,
  useTranslation,
} from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { TKeys } from '../../../enums';
import { amountConverterPipe, getBonusIslandImageSource } from '../../../helpers';
import ImgLogoPascal from '../../../assets/images/bonus-island/logo-pascal.svg';
import ImgNewBonusIslandBox from '../../../assets/images/bonus-island/img-box-money.png';
import { bonusIslandStore } from '../../../store/bonusIslandStore';

export const BonusIslandNotifierPopUp = observer(() => {
  const { ranges } = bonusIslandStore;
  const { precision = 2, currencyCode } = userInfoStore;

  const t = useTranslation();
  const { [DefaultQueryParams.Culture]: culture } = parseQuery(window.location.search);

  const [tournamentTotalPrizeFund, setTournamentTotalPrizeFund] = useState(0);
  const { ranges: tournamentRanges = [] } = ranges;

  useEffect(() => {
    if (tournamentRanges.length) {
      const allTournamentTotalPrizeFund = tournamentRanges.reduce((acc, curr) => {
        return (
          acc +
          parseNumberByPrecision(1, curr.overalPrizeFund, precision) +
          parseNumberByPrecision(1, curr.totalPrizeFund, precision)
        );
      }, 0);
      setTournamentTotalPrizeFund(allTournamentTotalPrizeFund);
    }
  }, [tournamentRanges, precision]);

  return tournamentRanges && tournamentRanges.length ? (
    <div className='bonus-island-new-popup-wrp'>
      <div className='bonus-island-new-popup-inner'>
        <img
          src={getBonusIslandImageSource(culture)}
          className='bonus-island-new-img'
          alt='Bonus Island'
        />
        <p className='bonus-island-new-text'>
          {setTranslationValues(t('BONUS_ISLAND_HOVER_MESSAGE_1'), {
            currency: currencyCode,
            tournamentTotalPrizeFundText: getAmountWithCurrency({
              amount: amountConverterPipe(parseNumberByPrecision(1, tournamentTotalPrizeFund)),
              isShowRealCurrency: true,
            }),
          })}
        </p>
        <div className='bonus-island-new-popup-btn-wrp'>
          <div className='new-b-i-logo-block'>
            <img src={ImgLogoPascal} alt='Pascal Gaming' />
          </div>
          <div className='new-b-i-btn-block'>
            <button
              className='new-b-i-btn active'
              onClick={() => {
                userSettingsStore.setGameSpecificLocalStorageDataByKey(
                  'isBonusIslandNotifier',
                  false
                );
              }}
            >
              <span title={t(TKeys.ok)}>{t(TKeys.ok)}</span>
            </button>
          </div>
          <div className='new-b-i-treasure-box'>
            <img src={ImgNewBonusIslandBox} alt='Box' />
          </div>
        </div>
      </div>
    </div>
  ) : null;
});
